import { Permissions, useAuthenticationService } from '../authentication/authentication-service';

export const useCanEditEmployee = () => {
  const [role, permission] = useAuthenticationService(state => [state.role, state.user?.profile.permission]);
  const canEdit = permission?.includes(Permissions.EmployeeUpdate) ?? false;

  return canEdit;
};
